import {BumpDatum} from '@nivo/bump'

// top ten block response

export interface TopTenBlocksResponseBody {
  message: string
  response: TopTenBlocksResponse[]
}
export interface TopTenBlocksResponse {
  name: string
  email: string | null
  entityType: string
  policyViolations?: number
  malwareBlocks?: number
  cacBlocks?: number
  cacViolations?: number
  dlpViolations?: number
}

// policy violation summary response

export interface TopViolationsByTypeResponseBody {
  message: string
  response: TopViolationsByTypeResponse
}
export interface TopViolationsByTypeResponse {
  policy: TopViolationsByType
  malware: TopViolationsByType
  cac: TopViolationsByType
  dlp: TopViolationsByType
}

export interface TopViolationsByType {
  total: number
  details: TopViolationsDetail[]
}

export interface PolicyTopViolations {
  totalViolations: number
  details: TopViolationsDetail[]
}

export interface MalwareTopViolations {
  totalBlocks: number
  details: TopViolationsDetail[]
}

export interface CacTopViolations {
  totalBlocks: number
  details: TopViolationsDetail[]
}

export interface DlpTopViolations {
  totalViolations: number
  details: TopViolationsDetail[]
}

export interface TopViolationsDetail {
  name: string
  count: number
}

// policy violation transactions response
export interface PolicyViolationTransactionsResponse {
  policy: PolicyTransactions
  malware: MalwareFileScanned
  cloudAppControl: CACTransactions
  a7DayTrendBlocks: A7DayTrendBlock[]
}

export interface A7DayTrendBlock {
  date: string
  policyViolations: number
  malwareBlocks: number
  cloudAppControl: number
}

export interface A7DayTrendChartSeries {
  id: string
  name: string
  data: BumpDatum[]
}

export interface CACTransactions {
  totalTransactions: number
}

export interface MalwareFileScanned {
  filesScanned: number
}

export interface PolicyTransactions {
  totalTransactions: number
}

// Redux state interfaces
export interface TopTenBlocksState extends TopTenBlocksResponse {
  totalBlocks: number
}

export interface AnalyticsPolicy7DayTrendState {
  policy: PolicyTopViolations & PolicyTransactions
  malware: MalwareTopViolations & MalwareFileScanned
  cloudAppControl: CacTopViolations & CACTransactions
  dlp: DlpTopViolations
  a7DayTrendBlocks: A7DayTrendBlock[]
}

// Redux action interfaces

export interface GetTopTenBlocksAction {
  filter: GetTopTenBlocksActionFilter
}

export interface GetTopTenBlocksActionFilter {
  policyTypes: POLICY_TYPE[]
  entities: RESOURCE_TYPE[]
}

export enum POLICY_TYPE {
  Policy = 'web_policy',
  Malware = 'malware',
  CAC = 'cac',
  DLP = 'dlp',
}

export enum POLICY_VERDICT {
  Verdict1 = 'Blocked',
  Verdict2 = 'Warning',
  Verdict4 = 'Monitored',
}

export enum RESOURCE_TYPE {
  Users = 'users',
  Location = 'location',
  Groups = 'groups',
}

// remove this once, API supports consistent resource type value
export enum RESOURCE_TYPE_SINGULAR {
  User = 'user',
  Location = 'location',
  Group = 'group',
}

export enum POLICY_TYPE_MAPPING {
  web_policy = 'Policy',
  cac = 'CAC',
  malware = 'Malware',
  dlp = 'DLP',
}
